import {
    EuiBasicTableColumn,
    EuiFlexGroup,
    EuiFlexItem,
    EuiHealth,
    EuiInMemoryTable,
    EuiPanel,
    EuiTitle
} from "@elastic/eui";
import React, {useState} from "react";
import {useGetAddonsQuery, useUpdateAddonMutation} from "../../api/rtkQueryApi/AddonsApi";
import {Addon} from "../../api/entities/Addon";
import {JSONClone} from "../../utils/CopyUtils";
import {AddonEditor} from "./AddonEditor";
import {NumberToCurrency} from "../../utils/Formatters";

export const AddonManagement: React.FC = () => {
    const addonsQuery = useGetAddonsQuery();
    const [updateAddon, updateAddonQuery] = useUpdateAddonMutation();
    const [editingAddon, setEditingAddon] = useState<Addon>();

    const onAddonSelected = (addon: Addon) => {
        setEditingAddon(JSONClone(addon));
    }

    const onUpdateAddon = (addon: Addon) => {
        setEditingAddon(addon);
    }

    const onSaveClick = () => {
        if (editingAddon) {
            updateAddon({ id: editingAddon.id, name: editingAddon.name, description: editingAddon.description})
        }
    }

    const addonColumns: EuiBasicTableColumn<Addon>[] = [
        {
            field: '',
            width: '40px',
            render: (addon: Addon) => addon.id === editingAddon?.id ?
                <EuiHealth color="primary" /> : '',
        },
        {
            field: 'name',
            name: 'Name',
        },
        {
            field: 'price',
            name: 'Price',
            render: (price: number) => NumberToCurrency(price),
        },
        {
            field: 'orderType',
            name: 'Duration',
        },
        {
            field: '',
            name: 'Actions',
            actions: [
                {
                    name: 'Edit',
                    description: 'Edit',
                    type: 'icon',
                    icon: 'pencil',
                    onClick: (addon: Addon) => onAddonSelected(addon),
                },
            ],
        },
    ];

    return (
        <EuiFlexGroup>
            <EuiFlexItem>
                <EuiPanel hasShadow={false} hasBorder={true}>
                    <EuiTitle size={'xxs'}>
                        <h2>Addons</h2>
                    </EuiTitle>
                    <EuiInMemoryTable
                        items={addonsQuery.data ?? []}
                        itemId="productGroup"
                        columns={addonColumns}
                    />
                </EuiPanel>
            </EuiFlexItem>
            <EuiFlexItem>
                <span>
                    {editingAddon && (
                        <AddonEditor addon={editingAddon} onUpdateAddon={onUpdateAddon} onSaveClick={onSaveClick} isLoading={updateAddonQuery.isLoading} isDisabled={updateAddonQuery.isLoading}/>
                    )}
                </span>
            </EuiFlexItem>
        </EuiFlexGroup>
    )
}